import { ErrorDetail } from '../../types';

import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';

import { DataGrid } from 'components/shared';

import { useGetColumnDefs } from './hooks/useGetColumnDefs';

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

interface Props {
  errors: ErrorDetail[];
}

export const ErrorDataGrid = ({ errors }: Props) => {
  const columns = useGetColumnDefs();
  return (
    <DataGrid
      getRowId={(data) => data.id}
      columns={columns}
      rows={errors}
      components={{
        Toolbar: CustomToolbar
      }}
    />
  );
};
